import React from "react";
import PropTypes from "prop-types";
import styles from "./DeleteFeedItemBar.module.css";
import Button from "../Button";

/**
 * Interactive component.
 * A bar that allows the user to delete an existing feed item.
 */
export function DeleteFeedItemBar({ onClick }) {
  return (
    <div className={styles.container}>
      <div className={styles.buttonContainer}>
        <Button
          text={"Delete Feed Item"}
          onClick={onClick}
          className={styles.button}
        />
      </div>
    </div>
  );
}

DeleteFeedItemBar.propTypes = {
  /**
   * Src of the banner image.
   */
  bannerSrc: PropTypes.string,
};
